import React, { FC } from 'react'
import { SVGProps } from './types'

export const QuestionMark: FC<SVGProps> = ({ size, color, onClick }) => {
  return (
    <svg
      fill={color}
      width={size}
      height={size}
      viewBox="-6.5 0 32 32"
      xmlns="http://www.w3.org/2000/svg"
      onClick={onClick}
    >
      <path d="M5.875 11.531h-2.313c-0.219-0.719-0.375-1.438-0.375-2.219 0-3.938 2.531-6.563 6.469-6.563 3.656 0 5.969 2 6.375 5.563 0.031 0.25 0.031 0.531 0.031 0.813 0 1.656-0.438 3.063-1.563 4.219-1.094 1.094-1.844 1.813-3.031 2.844-1.281 1.125-1.281 3.063-1.281 4.5h-2.406c0-3.375 0.75-4.781 1.844-5.875 1.063-1.063 2.594-2 3.406-3.031 0.688-0.813 0.875-1.781 0.875-2.656 0-2.719-1.531-4.25-4.25-4.25-2.75 0-4.313 1.719-4.313 4.438 0 0.813 0.188 1.531 0.531 2.219zM7.781 23.188h2.406v2.406h-2.406v-2.406z" />
    </svg>
  )
}
